/* eslint-disable no-dupe-keys */
export default {
  bank_account: {
    name: '银行账户',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '银行卡户名',
      number: '银行卡账号',
      bank_name: '开户行',
      service_provider_id: '所属运营商',
      description: '备注',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_name: '查询银行卡户名',
      search_number: '查询银行卡账号',
      search_bank_name: '查询开户行',
      input_name: '请输入银行卡户名',
      input_number: '请输入银行卡账号',
      input_bank_name: '请输入开户行',
      input_description: '请输入备注',
      search_keyword: '查询 户名/卡号/开户行'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标题
    titles: {
      base_info: '基本信息'
    }
  }
}
